//var app_proposals_table_all = $('#app-proposals-table-all');

if ($('#app-control_tower_agency-table').length) {
    var data_table_order = [0, "desc"];
    var app_buyer_agencies_table_all = $('#app-control_tower_agency-table').DataTable({
        "processing": true,
        "serverSide": true,
        ajax: {
            url: '/control_tower_agencies/index',
            dataSrc: 'data',
        },
        order: [0, "desc"],
        columns: [
            {data: 'id'},//0
            {data: 'name'},//1
            {data: 'main_email'},//2
            {data: 'main_phone'},//3
            {data: 'main_address'},//4
            {data: 'created_at_format'},//5
            {data: 'active'},//6
            {data: 'id'} //7
        ],
        // destroy: true,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 0,
                "visible": true,
                "orderable": false,
                "className": "text-center",
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = '';
                    if (parseInt(rowData.active) === 0  && parseInt(rowData.rep_moved_to) === 0 && parseInt(rowData.vendors_got) === 0 && parseInt(rowData.no_vendors) === 0)
                       html = ' <div class="checkbox checkbox-danger ct_agencies_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_ct_agencies[]" value="' + rowData.id + '" ><label for="' + rowData.id + '"> </label></div>';
                    $(td).html(html);
                }
            },
            {
                "targets": 1,
                "orderable": true,
                "visible": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var style = parseInt(rowData.vendors_got) === 1 || parseInt(rowData.no_vendors) === 1 ? 'text-decoration: line-through;' : '';
                    var title = parseInt(rowData.vendors_got) === 1 ? 'This Station cannot be approved because it has requested vendors that are already assigned for another Station' : '';
                    title = parseInt(rowData.no_vendors) === 1 ? 'This Station cannot be approved because it has requested no vendors.' : title;
                    title = parseInt(rowData.rep_moved_to) > 0 ? "The Rep has been reassigned to '" + rowData.moved_to_station_name + "' and is no longer associated with this Station." : title;
                    var html = '<span style="'+ style +'" data-toggle="tooltip" data-animation="" title="'+ title +'" >'+ cellData +'</span>'
                    $(td).html(html);
                }
            },
            {
                "targets": 2,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    if(parseInt(rowData.rep_moved_to) > 0) {
                       var title = "The Rep has been reassigned to '" + rowData.moved_to_station_name + "' and is no longer associated with this Station.";
                        var html = '<span style="color: #868e96; text-decoration: line-through;" data-toggle="tooltip" data-animation="" title="' + title + '" >' + cellData + ' (Reassigned to ' + rowData.moved_to_station_name +')</span>'
                    }else
                        var html  = cellData;

                    $(td).html(html);
                }
            },
            {
                "targets": 3,
                "orderable": true,
            },
            {
                "targets": 4,
                "orderable": true,
            },
            {
                "targets": 5,
                "orderable": true,
            },
            {
                "targets": 6,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log('rowData', rowData)
                    var html = '';
                    var auxHtml = '';
                    var html = parseInt(cellData) === 0 ? 'New' : 'Approved';
                    html = parseInt(cellData) === 1 ? 'Approved' : html;
                    html = parseInt(cellData) === 2 ? 'Denied' : html;
                    html = parseInt(cellData) === 3 ? 'Rep reassigned' : html;
                    var style = html === 'New' ? 'font-weight: 800; color: darkred;' : '';
                    var html_full = '<span style="'+ style +'"> '+ html +'</span>';


                    $(td).html(html);
                }
            },
            {
                "targets": 7,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log('rowData', rowData)
                    var html = '';
                    var auxHtml = '';
                    var html = '<div class="btn-group">\n' +
                        '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                        '                <i class="fa fa-ellipsis-v"></i>\n' +
                        '                <span class="sr-only">Toggle Dropdown</span>\n' +
                        '            </button>\n' +
                        '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                         '                             <li class="ms-hover">' + '<a class="vendors-ct_agencies" href="javascript:void(0)" data-name="' + rowData.name + '" data-id="' + cellData + '" >' + '<i class="fa fa-list"></i>  Vendors' + '</a>' + '</li>' ;

                           if(rowData.active === 1)
                                 html +=   '   <li class="ms-hover">' + '<a class="ghost_this_agency" href="javascript:void(0)" data-name="' + rowData.name + '" data-id="' + rowData.id + '" >' + '<i class="fa fa-user"></i>  Ghost' + '</a>' + '</li>' ;


                           if(rowData.active === 0 && parseInt(rowData.vendors_got) === 1 && parseInt(rowData.rep_moved_to) === 0)
                                 html +=  ' <li class="ms-hover">' + '<a class="move_user_to_existing_station" href="javascript:void(0)" data-name="' + rowData.name + '" data-id="' + rowData.id + '" >' + '<i class="fa fa-user"></i>  Move Rep to Existing Station' + '</a>' + '</li>' ;


                       html +=    '  </ul>' +
                        '  </div>';

                    $(td).html(html);
                }
            }
        ]
    });

    $('#app-control_tower_agency-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries = len;
    });
    $('#app-control_tower_agency-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order = [len[0].col, ""+len[0].dir+""];
    });

    $('#select_all_ct_agencies').on('click', function (e) {
        $('#app-control_tower_agency-table input:checkbox').each(function () {
            $(this).prop('checked', true);
        });
    });
    $('#deselect_all_ct_agencies').on('click', function (e) {
        $('#app-control_tower_agency-table input:checkbox').prop('checked', false);
    });

    $('#set_t_approved').on('click', function (e) {
        var ct_agencies = [];
        $('.ct_agencies_check input[type=checkbox]').each(function () {
            if (this.checked)
                ct_agencies.push($(this).val());
        });
        if(ct_agencies.length > 0)
           $('#approveControlTowerAgency').modal('show');
        else
            swal({
                    title: 'Warning!',
                    text: 'Please selecte at least one Agency...',
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Ok",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {});
    });

    $('#approve_ct_agency').on('click', function (){
        show_overlay_loader("#approveControlTowerAgency");
        var params = { agencies_ids : [] };
        $('.ct_agencies_check input[type=checkbox]').each(function () {
            if (this.checked)
                params.agencies_ids.push($(this).val());
        });
        $.ajax({
            type: 'POST',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            url: '/control_tower/agencies/approve',
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                $('#app-control_tower_agency-table').DataTable().ajax.reload();
                global_notification("success", "Agencies approved, email(s) sent to Reps");
                hide_overlay_loader("#approveControlTowerAgency");
                $('#approveControlTowerAgency').modal('hide');
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
                hide_overlay_loader("#approveControlTowerAgency");
            }
        });

    });

    $('#app-control_tower_agency-table').on('click', '.vendors-ct_agencies', function (){
        show_loader();
        ControlTowerAgencyVendorsColDef = [
            {
                field: 'name',
                headerName: "Vendor Name",
                width: 200,
                editable: false,
                cellClassRules: {
                    'ag-cell-color-strike-thru': function (params) {
                        if (params.node.data.active === 0 && params.node.data.vendor_agency_id > 0)
                            return true;
                        else
                            return false;
                    },
                },
            },
            {
                field: 'agency_name',
                headerName: "Linked to Agency",
                width: 300,
                editable: false,
            },
        ];
        ControlTowerAgencyVendorsGrid = {
            columnDefs: ControlTowerAgencyVendorsColDef,
            defaultColDef: {
                width: 150,
                suppressToolPanel: true
            },
            rowSelection: 'single',
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            suppressRowHoverClass: true,
            suppressParentsInRowNodes: true,
            toolPanelSuppressValues: true,
            toolPanelSuppressRowGroups: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            stopEditingWhenGridLosesFocus: true,
            suppressRowClickSelection: true,
            icons: {
                //  groupExpanded: '<i class="fa fa-fw fa-minus-square"></i>',
                //  groupContracted: '<i class="fa fa-fw fa-plus-square-o"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },
        };
        $.ajax({
            type: 'GET',
            url: '/control_tower/agency/vendors/list/' + $(this).attr('data-id'),
            dataType: 'json',
            encode: true,
            success: function (data) {
                if(typeof data.no_vendors !== 'undefined'){
                    swal({
                            title: 'Warning!',
                            text: 'This Control Tower Agency has not requested any vendors to approve. ',
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "Ok",
                            cancelButtonText: "Cancel",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {});
                }else {
                    ControlTowerAgencyVendorsGrid.rowData = [];
                    ControlTowerAgencyVendorsGrid.rowData = data;
                    $('#controlTowerAgencyVendorsGrid').html("");
                    var AgencyBuyerContactsGridGrid = document.querySelector('#controlTowerAgencyVendorsGrid');
                    var g5 = new agGrid.Grid(AgencyBuyerContactsGridGrid, ControlTowerAgencyVendorsGrid);
                    $('#ControlTowerAgencyVendorsModal').modal('show');
                }
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });
    });

    $('#app-control_tower_agency-table').on('click', '.ghost_this_agency', function (){
        var new_agency = $(this).attr('data-id');
        show_loader();
        $.ajax({
            type: 'GET',
            url: '/control_tower/agency/ghost/' + new_agency,
            dataType: 'json',
            encode: true,
            success: function (data) {
                location.reload();
                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
                debug(xhr.responseText);
            }
        });

    });

    var moveUserStations = {};
    $('#app-control_tower_agency-table').on('click', '.move_user_to_existing_station', function () {
        var current_agency = $(this).attr('data-id');
        $('#confirm_change_rep').attr('data-agency', current_agency)
        $('#move_user_current_station_id').val(current_agency);
        $('#move_user_requested_vendors').html('');
        $('#move_user_destination_station').html('<option value="">Select a Station</option>');

        $('#move_user_station_details').hide().html('');
       // $('#confirm_move_user_to_existing_station').prop('disabled', true);

        show_loader();
        $.ajax({
            type: 'GET',
            url: '/control_tower/agency/move_user/' + current_agency,
            dataType: 'json',
            success: function (data) {
                moveUserStations = data;
                var vendorsHtml = '';
                $.each(data.requested_vendors || [], function (index, vendor) {
                    var style_tr = 'padding:8px 10px; border-bottom:1px solid #E8E8E8;' + (index % 2 !== 0 ? 'background-color:#F8F8F8;' : 'background-color:#FFFFFF;');
                    var vendorName = vendor.name || vendor.vendor_name;
                    if (parseInt(vendor.agency_id) === 0) {
                        vendorsHtml += '<div style="' + style_tr + '">' +
                            '<i class="fa fa-shopping-cart fa-fw"></i> ' +
                            '<strong>' + vendorName + '</strong>' +
                            '<span style="color:#C46A1A; font-weight:600;">' +
                            ' &nbsp;→ Not assigned to any Station' +
                            '</span>' +
                            '</div>';

                    } else {
                        vendorsHtml += '<div style="' + style_tr + '">' +
                            '<i class="fa fa-shopping-cart fa-fw"></i> ' +
                            '<strong>' + vendorName + '</strong>' +
                            '<span style="color:#2E8B57;">' +
                            ' &nbsp;→ Assigned to <strong>' + vendor.agency_name + '</strong>' +
                            '</span>' +
                            '</div>';
                    }

                });

                if (vendorsHtml === '')
                    vendorsHtml = 'No requested vendors found.';

                $('#move_user_requested_vendors').html(vendorsHtml);

                $.each(data.stations, function (index, station) {
                    var stationName = station.name || station.agency_name || ('Station #' + station.id);
                    var matchingCount = parseInt(station.matching_vendor_count) || 0;
                    var optionText = stationName;

                    if (matchingCount > 0)
                        optionText += ' — ' + matchingCount + ' matching vendor' + (matchingCount === 1 ? '' : 's');

                    $('#move_user_destination_station').append(
                        $('<option>', {
                            value: station.id,
                            text: optionText,
                            'data-name': stationName
                        })
                    );
                });

                $('#MoveUserToExistingStation').modal('show');
                hide_loader();
            },

            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });

    $('#confirm_move_user_to_existing_station').on('click', function () {
        var selectedStationId = $('#move_user_destination_station option:selected').val();
       // var selectedStationName = $('#move_user_destination_station option:selected').attr('data-name');
        var warningHtml = '';
        if(typeof selectedStationId === "undefined" || selectedStationId === "" || isNaN(parseInt(selectedStationId))){
            warningHtml += '<div style="font-size: 15px; line-height: 1.6;">' +
                'Please select the <span style="font-weight: 600; color: #b7791f">Station</span> to which this Rep should be reassigned before continuing.' +
                '<br><br>' +
                'Once a Station is selected, the system will evaluate the requested vendors and display any warnings or additional actions that may be required.' +
                '</div>';
            $('#confirm_change_rep').hide();
        }
        else {
            $('#confirm_change_rep').show();
            var selectedStationName = $('#move_user_destination_station option:selected').data('name');
            // Vendors that belong to another Station
            var conflictingVendors = [];
            $.each(moveUserStations.requested_vendors || [], function (i, vendor) {
                if (parseInt(vendor.agency_id) !== 0 && parseInt(vendor.agency_id) !== parseInt(selectedStationId))
                    conflictingVendors.push(vendor);
            });

            if (conflictingVendors.length > 0) {
                warningHtml += '<div style="font-size: 15px; line-height: 1.6;">' +
                    'Some of the requested vendors are currently assigned to different Stations. ' +
                    'If you reassign this user to <span style="font-weight: 600; color: #b7791f">' + selectedStationName + '</span>, ' +
                    'only the vendors that already belong to the selected Station ' +
                    '(and any unassigned vendors) will be associated with it.<br><br>' +
                    'The following vendors will remain assigned to their current Stations:';


                warningHtml += '<ul style="margin-top: 12px; margin-left: 25px; padding-left: 10px; list-style: none;">';
                $.each(conflictingVendors, function (i, vendor) {
                    warningHtml += '<li style="margin-bottom: 6px; padding-left: 5px;">' +
                        '<i class="fa fa-shopping-cart fa-fw" style="margin-right: 6px; color: #b7791f;"></i>' +
                        '<strong>' + vendor.name + '</strong> ' +
                        '<span style="color: #777;">(' + vendor.agency_name + ')</span>' +
                        '</li>';
                });
                warningHtml += '</ul></div>';
            } else if (typeof moveUserStations.unassigned_vendors !== 'undefined' && moveUserStations.unassigned_vendors.length > 0) {
                warningHtml +=
                    '<div style="font-size: 15px; line-height: 1.6;">' +
                    'By reassigning this Rep to <span style="font-weight: 600; color: #b7791f">' +
                    selectedStationName +
                    '</span>, all requested vendors that are not currently assigned to any Station will also be added to the selected Station.' +
                    '</div>';

                warningHtml +=
                    '<div style="font-size: 12px;margin-top:15px; margin-left:25px; font-weight:600; color:#555;">' +
                    'Unassigned Vendors:' +
                    '</div>';

                warningHtml += '<ul style="margin-top: 8px; margin-left: 25px; padding-left: 10px; list-style: none;">';

                $.each(moveUserStations.unassigned_vendors, function (i, vendor) {

                    warningHtml +=
                        '<li style="margin-bottom: 6px; padding-left: 5px;">' +
                        '<i class="fa fa-shopping-cart fa-fw" style="margin-right: 6px; color: #b7791f;"></i>' +
                        '<strong>' + vendor.name + '</strong>' +
                        '</li>';

                });

                warningHtml += '</ul>';
            } else {
                warningHtml += '<div style="font-size: 15px; line-height: 1.6;">Are you sure you want to reassign this Rep to <span style="font-weight: 600; color: #b7791f">' + selectedStationName + '</span>' +
                    '</strong>? This action cannot be undone automatically.' +
                    '</div>';
            }
        }
        $('#warning_change_rep_div').html(warningHtml);
        $('#confirmRepChangeModal').modal('show');

    });

    $('#confirm_change_rep').on('click', function (){
        var selectedStationId = $('#move_user_destination_station option:selected').val();
        var currentStationID = $('#confirm_change_rep').attr('data-agency');
        var params = {
            'selectedStationId' : selectedStationId,
            'currentStationID' : currentStationID,
        };
        show_overlay_loader("#confirmRepChangeModal");
        $.ajax({
            type: 'POST',
            url: '/control_tower/agencies/reassign_rep',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: JSON.stringify(params),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data) {
                global_notification("success", "Representative have been change...");
                location.reload();
                hide_overlay_loader("#confirmRepChangeModal");
                //$('#confirmRepChangeModal').modal('hide');
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
                hide_overlay_loader("#confirmRepChangeModal");
            }
        });
    });

}
